module.exports = __webpack_public_path__ + "img/index_fix.f54c3f7a.jpg";